module.exports = __webpack_public_path__ + "static/media/19.2b233235.jpg";